import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import * as AdaptiveCards from "adaptivecards";
import { dialog, app } from "@microsoft/teams-js";
import { markDownToHtml } from '../../helpers/formattingHelper'
import FileUploader from '../NewMessage/FileUploader/fileUploader'
import CheckBoxWithTooltip from '../NewMessage/CheckBoxWithTooltip/checkBoxWithTooltip'
import ThumbsUp from '../../assets/thumbs-up.svg?react';
import './newTemplate.scss';
import {
    getTemplate, createTemplateColor,
    createTemplate, updateTemplate, searchGroups, getAssignedGroupsInfo
} from '../../apis/messageListApi';
import { ImageUtil } from '../../utility/imageutility';
import { TFunction } from "i18next";
import { getInitAdaptiveCard, setTemplateBanner, setTemplateColor, setTemplateTextColor, setTemplateElements } from '../AdaptiveCard/adaptiveCard';
import { DndContext, closestCenter, DragEndEvent } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { HexColorPicker } from "react-colorful";
import { getAllTemplatesList, getTemplateColorsList } from '../../actions';
import DragIcon from '../../assets/arrow-move.svg?react';
import { Button, Spinner, Input, Label, Tooltip, Text, Option, Dropdown, Checkbox, CheckboxOnChangeData } from "@fluentui/react-components"
import { Info24Regular, Attach20Regular, PaintBrush20Regular, Delete20Regular, Add20Regular } from '@fluentui/react-icons';

import Multiselect from '../NewMessage/Multiselect/multiselect';
import { initializeTeamsApp } from '../../helpers/teamsApp';

export interface IOption {
    id: string,
    name: string,
    mail?: string
    image?: string
}

export interface IColorRGB {
    r: number,
    g: number,
    b: number,
}

export interface ITemplateColor {
    id: string,
    backgroundColorId: string,
    backgroundColorUrl: string,
}

export interface ITemplate {
    id?: string,
    templateName?: string,
    bannerUrl?: string,
    backgroundColorId?: string,
    backgroundColorUrl?: string,
    textColor?: string,
    isEmailEnabled?: boolean,
    authorGroups?: string[],
    emailOffSet?: number,
    allowSendAll?: boolean,
    isIncidentSummary?: boolean,
    isPowerAutomateEnabled?: boolean,
    elements?: string[],
    creatorId?: string,
    creatorName?: string,
}

export interface formState {
    topRef: React.RefObject<any>,
    card: any,
    exists: boolean,
    page: string,
    errorTemplateNameMessage: string,
    errorBannerUrlMessage: string,
    errorColorUrlMessage: string,
    colorRGB: IColorRGB,
    loader: boolean,
    id?: string,
    templateName: string,
    bannerUrl: string,
    backgroundColorId: string,
    backgroundColorUrl: string,
    textColor: string,
    textColorDisplay: string,
    authorGroups: string[],
    selectedAuthorGroups: IOption[],
    selectedAuthorGroupsNum: number,
    noGroupsMessage: string,
    isEmailEnabled: boolean,
    emailOffSet: number,
    allowSendAll: boolean,
    isIncidentSummary: boolean,
    isPowerAutomateEnabled: boolean,
    elements: string[],
    creatorId: string,
    creatorName: string,
    forceDisableButton: boolean,
    loadingGroups: boolean;
    unstablePinned: boolean,
    allTemplates: any[],
    allTemplateColors: any[],
    allTextColors: any[],
    sectionsCount: number,
    sections: Array<Array<{ value: string, enabled: boolean }>>
}

export interface INewTemplateProps extends WithTranslation {
    templatesList: ITemplate[];
    templateColorsList: ITemplateColor[];
    selectTemplate?: any;
    onBackToList: any;
    getAllTemplatesList?: any;
    getTemplateColorsList?: any;
}

const SortableItem = ({ value, enabled, onCheckboxChange, mapName }: {
    value: string;
    enabled: boolean;
    onCheckboxChange: (checked: boolean) => void;
    mapName: (value: string) => string;
}) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: value });
    const style = { transform: CSS.Transform.toString(transform), transition };

    return (
        <li className='templateContentContainer__draganddrop-list-item' ref={setNodeRef} style={style}>
            <span {...attributes} {...listeners}><DragIcon /></span>
            <Checkbox checked={enabled} onChange={(_: React.ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => onCheckboxChange(!!data.checked)} />
            <Label className="listLabel">{mapName(value)}</Label>
        </li>
    );
};

class NewTemplate extends React.Component<INewTemplateProps, formState> {
    readonly localize: TFunction;
    private card: any;

    private maximumSections: number = 5;

    private defaultSectionElements: Array<string> = ["Title", "ImageLink", "VideoLink", "Summary", "SecondarySummary", "Author", "Actions",];

    private getDefaultSections = (): Array<Array<{ value: string, enabled: boolean }>> => Array(this.maximumSections)
        .fill(this.defaultSectionElements)
        .map((array: Array<string>, index) => array.map((element: string) => ({ value: element + index, enabled: false })));

    private defaultElements = (): Array<string> => Array(this.maximumSections)
        .fill(this.defaultSectionElements)
        .map((array: Array<string>, index) => array.map((element: string) => element + index))
        .flat();

    private mapTemplateElementName = (key: string) => {
        var dynamicTemplateElementRegex = /^([A-Za-z]+)(\d+)$/
        const matches = key.match(dynamicTemplateElementRegex);

        if (matches) {
            return `${matches[1]} (${matches[2]})`;
        }

        return key;
    }

    constructor(props: INewTemplateProps) {
        super(props);
        this.localize = this.props.t;
        this.card = getInitAdaptiveCard(this.localize);

        this.state = {
            topRef: React.createRef(),
            card: this.card,
            page: "TemplateCreation",
            exists: false,
            errorTemplateNameMessage: "",
            errorBannerUrlMessage: "",
            errorColorUrlMessage: "",
            colorRGB: { r: 0, g: 0, b: 0 },
            loader: true,
            templateName: "",
            bannerUrl: "",
            backgroundColorId: "",
            backgroundColorUrl: "",
            textColor: "dark",
            textColorDisplay: "Black",
            authorGroups: [],
            selectedAuthorGroups: [],
            selectedAuthorGroupsNum: 0,
            noGroupsMessage: "",
            isEmailEnabled: false,
            emailOffSet: 5,
            allowSendAll: false,
            isIncidentSummary: false,
            isPowerAutomateEnabled: false,
            elements: [],
            creatorId: "",
            creatorName: "",
            forceDisableButton: false,
            loadingGroups: false,
            unstablePinned: true,
            allTemplates: [],
            allTemplateColors: [],
            allTextColors: [],
            sectionsCount: this.maximumSections,
            sections: this.getDefaultSections()
        };
    }

    public async componentDidMount() {
        await initializeTeamsApp();

        await this.props.getAllTemplatesList()
        await this.props.getTemplateColorsList()

        var allTemplatesList = this.props.templatesList;

        if (this.props.selectTemplate) {

            var templateId = this.props.selectTemplate.id;
            let response = await getTemplate(templateId);

            const templateDetails = response.data;

            setTemplateBanner(this.card, templateDetails.bannerUrl);
            setTemplateColor(this.card, templateDetails.backgroundColorUrl);
            setTemplateTextColor(this.card, templateDetails.textColor);

            this.onChangeColorHex(templateDetails.backgroundColorId)

            let assignedGroups = await getAssignedGroupsInfo(templateId);
            var options = this.makeDropdownAuthorGroups(assignedGroups.data);

            var filteredElements: Array<string> = templateDetails.elements.filter((element: string) => this.defaultElements().flat().includes(element));

            this.setState(previous => ({
                card: this.card,
                exists: !!templateDetails.IsDynamic,
                id: templateDetails.id,
                templateName: templateDetails.templateName,
                bannerUrl: templateDetails.bannerUrl,
                backgroundColorId: templateDetails.backgroundColorId,
                backgroundColorUrl: templateDetails.backgroundColorUrl,
                textColor: templateDetails.textColor,
                isEmailEnabled: templateDetails.isEmailEnabled,
                selectedAuthorGroups: options,
                selectedAuthorGroupsNum: options.length,
                emailOffSet: templateDetails.emailOffSet,
                allowSendAll: templateDetails.allowSendAll,
                isPowerAutomateEnabled: templateDetails.isPowerAutomateEnabled,
                isIncidentSummary: templateDetails.isIncidentSummary,
                elements: filteredElements,
                sections: previous.sections.map((section) => section.map(({ value, enabled }) => ({
                    value: value,
                    enabled: filteredElements.includes(value)
                }))),
                creatorId: templateDetails.creatorId,
                creatorName: templateDetails.creatorName,
            }), () => {
                setTemplateElements(this.localize, this.card, this.state.elements, this.state.textColor)
                this.updateCard();
            });
        }

        const templateColorsList = this.makeDropdownColors(
            this.props.templateColorsList
        );
        this.setState({
            loader: false,
            card: this.card,
            allTemplates: allTemplatesList,
            allTemplateColors: templateColorsList,
            backgroundColorId: "EDF5FF",
            allTextColors: this.makeDropdownTextColors()
        }, () => {
            this.updateCard();
        });

        //- Handle the Esc key
        document.addEventListener("keydown", this.escFunction, false);
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (this.state.exists) {
            this.updateCard();
        }
        if (this.state.page === "AssignAuthorsGroup" && prevState.page === "TemplateCreation") {
            //this.state.topRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    private makeDropdownAuthorGroups = (items: any[] | undefined) => {
        const resultedGroups: IOption[] = [];
        if (items) {
            items.forEach((group) => {
                resultedGroups.push({
                    id: group.id,
                    name: group.name,
                    mail: group.mail,

                });
            });
        }
        return resultedGroups;
    }

    private makeDropdownColors = (items: any[] | undefined) => {
        const resultedColors: IOption[] = [];
        if (items) {
            items.forEach((color) => {
                resultedColors.push({
                    id: color.backgroundColorUrl,
                    name: color.id,
                    image: ImageUtil.makeHexColorImage(`#${color.id}`),

                });
            });
        }
        return resultedColors;
    }

    private makeDropdownTextColors = () => {
        var items: any[] = [
            {
                id: "dark",
                name: "Black",
                hexColor: "000000"
            },
            {
                id: "light",
                name: "White",
                hexColor: "F0F0F0"
            },
            {
                id: "accent",
                name: "Blue",
                hexColor: "325BC9"
            },
            {
                id: "good",
                name: "Green",
                hexColor: "26C011"
            },
            {
                id: "warning",
                name: "Orange",
                hexColor: "FF9500"
            },
            {
                id: "attention",
                name: "Red",
                hexColor: "DE2C2C"
            }
        ]
        const resultedColors: IOption[] = [];
        items.forEach((color) => {
            resultedColors.push({
                id: color.id,
                name: color.name,
                image: ImageUtil.makeHexColorImage(`#${color.hexColor}`),

            });
        });
        return resultedColors;
    }

    private onColorsListChange = (event: any, itemsData: any) => {
        var backgroundColorUrl = this.state.allTemplateColors.find((f) => f.name === itemsData.optionValue).id;
        setTemplateColor(this.card, backgroundColorUrl)
        this.setState({
            backgroundColorUrl: backgroundColorUrl,
            card: this.card,
        }, () => {
            this.updateCard();
        });
        this.onChangeColorHex(itemsData.optionValue)
    }

    private onChangeColorHex = (hexColor: string) => {

        hexColor = hexColor.replace("#", "").toUpperCase()
        var convertToRGB = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);

        var colorAsRGB: IColorRGB = {
            r: convertToRGB ? parseInt(convertToRGB[1], 16) : 0,
            g: convertToRGB ? parseInt(convertToRGB[2], 16) : 0,
            b: convertToRGB ? parseInt(convertToRGB[3], 16) : 0,
        }

        this.setState({
            backgroundColorId: hexColor,
            colorRGB: colorAsRGB,
            errorColorUrlMessage: !convertToRGB ? "Invalid color input" : ""
        })
    }

    private onChangeColorRGB = (event: any, typeRGB: string) => {

        var updateRGBColor = this.state.colorRGB;
        var rgbColorNum = parseInt(event.target.value)

        rgbColorNum = rgbColorNum >= 255 ? 255 : rgbColorNum
        rgbColorNum = rgbColorNum <= 0 ? 0 : rgbColorNum

        if (typeRGB === "r") {
            updateRGBColor.r = rgbColorNum
        } else if (typeRGB === "g") {
            updateRGBColor.g = rgbColorNum
        } else if (typeRGB === "b") {
            updateRGBColor.b = rgbColorNum
        }

        var hexFromR = updateRGBColor.r.toString(16);
        hexFromR = hexFromR.length === 1 ? "0" + hexFromR : hexFromR;
        var hexFromG = updateRGBColor.g.toString(16);
        hexFromG = hexFromG.length === 1 ? "0" + hexFromG : hexFromG;
        var hexFromB = updateRGBColor.b.toString(16);
        hexFromB = hexFromB.length === 1 ? "0" + hexFromB : hexFromB;
        var newColorHex = hexFromR + hexFromG + hexFromB;

        this.setState({
            backgroundColorId: newColorHex.toUpperCase(),
            colorRGB: updateRGBColor,
        })
    }

    public componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    public render(): JSX.Element {
        const downloadIcon = <Attach20Regular />
        const colorIcon = <PaintBrush20Regular />
        const addIcon = <Add20Regular />
        if (this.state.loader) {
            return (
                <div className="loader">
                    <Spinner />
                </div>
            );
        } else {
            if (this.state.page === "TemplateCreation") {
                return (
                    <div className="templateModule" id="top" >
                        <div className="templateContainer">
                            <div className="templateContentContainer" >
                                <div className="templateContentContainer__input-container">
                                    <Label htmlFor='templateCreationTemplateNameInput'>{this.localize("TemplateNameText")}</Label>
                                    <Input
                                        value={this.state.templateName}
                                        onChange={this.onTemplateNameChanged}
                                        autoComplete="off"
                                        required
                                        id='templateCreationTemplateNameInput'
                                    />
                                </div>
                                {
                                    this.state.id && (
                                        <div className="templateContentContainer__input-container">
                                            <Label htmlFor='templateCreationBannerUrlInput'>Template ID</Label>
                                            <div className="templateContentContainer__image-source-container">
                                                <Input
                                                    className="image-source-container__link-input"
                                                    value={this.state.id}
                                                    placeholder="Template ID"
                                                    disabled={true}
                                                />

                                                <Tooltip
                                                    content="This is unique template identifier"
                                                    relationship='label'>
                                                    <Info24Regular
                                                        className="succeeded"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="templateContentContainer__input-container">
                                    <Label htmlFor='templateCreationBannerUrlInput'>{this.localize("BannerURL")}</Label>
                                    <div className="templateContentContainer__image-source-container">
                                        <Input
                                            className="image-source-container__link-input"
                                            value={this.state.bannerUrl}
                                            placeholder={this.localize("BannerURL")}
                                            onChange={(b: React.ChangeEvent<HTMLInputElement>) => this.onTemplateBannerChanged(b.target.value)}
                                            autoComplete="off"
                                            disabled={true}
                                            id='templateCreationBannerUrlInput'
                                        />

                                        <FileUploader
                                            buttonIcon={downloadIcon}
                                            buttonText={"Attach banner"}
                                            url="/content/uploadBanner"
                                            onSuccess={this.attachImage.bind(this)}
                                            acceptedFileTypes=".png,.jpg,.jpeg"
                                        />
                                        <Tooltip
                                            content="Image upload will be resized as 507x76. Upload recommended to be no less than 4:1, and must be in PNG, JPEG, or GIF format. Animated GIF is not supported."
                                            relationship='label'>
                                            <Info24Regular
                                                className="succeeded"
                                            />
                                        </Tooltip>
                                    </div>
                                    <Text className='errorText'>{this.state.errorBannerUrlMessage}</Text>
                                </div>
                                <div className="templateContentContainer__input-container">
                                    <Label htmlFor='templateCreationBannerUrlInput'>{this.localize("TemplateColor")}</Label>
                                    <div className="templateContentContainer__image-source-container">
                                        <Input
                                            className="image-source-container__link-input"
                                            value={this.state.backgroundColorId}
                                            placeholder={this.localize("TemplateColor")}
                                            onChange={(c: React.ChangeEvent<HTMLInputElement>) => this.onChangeColorHex(c.target.value)}
                                            autoComplete="off"
                                            id='templateCreationBackgroundColorIdInput'
                                        />

                                        <Button
                                            className="image-source-container__button"
                                            icon={colorIcon}
                                            onClick={() => this.onTemplateColorGenerated()}
                                            disabled={this.state.errorColorUrlMessage !== "" || !this.state.backgroundColorId}
                                            appearance='primary'
                                            type='button'>
                                            Generate Color
                                        </Button>
                                        <Tooltip
                                            content="You can input a valid Hex color, set of RGB colors or use the color selector."
                                            relationship='label'>
                                            <Info24Regular
                                                className="succeeded"
                                            />
                                        </Tooltip>
                                    </div>
                                    <Text className='errorText'>{this.state.errorColorUrlMessage}</Text>
                                </div>
                                <div className="templateContentContainer__color-source-container-pickColor">
                                    <div className="color-source-container">
                                        <Dropdown
                                            className="color-source-container__input"
                                            placeholder={this.localize("PlaceHolderTemplateColor")}
                                            value={this.state.backgroundColorId}
                                            onOptionSelect={this.onColorsListChange}
                                            mountNode={undefined}
                                        >
                                            {this.state.allTemplateColors.map(color => (
                                                <Option key={color.id} text={color.name}>
                                                    <img style={{ borderRadius: "50%", marginRight: "1rem" }}
                                                        alt={color.image}
                                                        src={color.image}
                                                    />
                                                    <Label>{color.name}</Label>
                                                </Option>
                                            ))}
                                        </Dropdown>
                                        <Label htmlFor='rgbColorRInput'>R</Label>
                                        <Input
                                            className="color-source-container__input"
                                            value={this.state.colorRGB.r.toString()}
                                            onChange={(c: React.ChangeEvent<HTMLInputElement>) => this.onChangeColorRGB(c, "r")}
                                            autoComplete="off"
                                            type='number'
                                            onChangeCapture={(c: React.ChangeEvent<HTMLInputElement>) => this.onChangeColorRGB(c, "r")}
                                            id='rgbColorRInput'
                                        />
                                        <Label htmlFor='rgbColorGInput'>G</Label>
                                        <Input
                                            className="color-source-container__input"
                                            value={this.state.colorRGB.g.toString()}
                                            onChange={(c: React.ChangeEvent<HTMLInputElement>) => this.onChangeColorRGB(c, "g")}
                                            autoComplete="off"
                                            type='number'
                                            onChangeCapture={(c: React.ChangeEvent<HTMLInputElement>) => this.onChangeColorRGB(c, "g")}
                                            id='rgbColorGInput'
                                        />
                                        <Label htmlFor='rgbColorBInput'>B</Label>
                                        <Input
                                            className="color-source-container__input"
                                            value={this.state.colorRGB.b.toString()}
                                            onChange={(c: React.ChangeEvent<HTMLInputElement>) => this.onChangeColorRGB(c, "b")}
                                            autoComplete="off"
                                            type='number'
                                            onChangeCapture={(c: React.ChangeEvent<HTMLInputElement>) => this.onChangeColorRGB(c, "b")}
                                            id='rgbColorBInput'
                                        />
                                    </div>
                                    <HexColorPicker
                                        color={this.state.backgroundColorId}
                                        onChange={(c: any) => this.onChangeColorHex(c)}
                                    />
                                </div>
                                <div className="templateContentContainer__input-container">
                                    <Label htmlFor='templateCreationTextColorInput'>{this.localize('TextColorText')}</Label>
                                    <Dropdown
                                        placeholder={this.localize("PlaceHolderTemplateColor")}
                                        value={this.state.textColorDisplay}
                                        onOptionSelect={this.onTextColorChange}
                                        id='templateCreationTextColorInput'
                                        selectedOptions={[this.state.textColor]}
                                        mountNode={undefined}
                                    >
                                        {this.state.allTextColors.map(color => (
                                            <Option key={color.id} value={color.id} text={color.name}>
                                                <img style={{ borderRadius: "50%", marginRight: "1rem" }}
                                                    alt={color.image}
                                                    src={color.image}
                                                />
                                                <Label>{color.name}</Label>
                                            </Option>
                                        ))}
                                    </Dropdown>
                                </div>
                                <div className="templateContentContainer__input-container">
                                    <hr className="elementsSeperator"></hr>
                                    <div className="templateContentContainer__image-source-container">
                                        <Label
                                            htmlFor='templateCreationTextColorInput'>
                                            {this.localize('ElementsOrderText')}
                                        </Label>
                                    </div>
                                    {this.state.sections.map((array, sectionIndex) => (
                                        <DndContext
                                            key={sectionIndex}
                                            collisionDetection={closestCenter}
                                            onDragEnd={(event: DragEndEvent) => this.onDragEnd(event, sectionIndex)}
                                        >
                                            <SortableContext
                                                items={array.map(item => item.value)}
                                                strategy={verticalListSortingStrategy}
                                            >
                                                <ul className="templateContentContainer__draganddrop-list">
                                                    Section {sectionIndex + 1}
                                                    {array.map(({ value, enabled }, elementIndex) => (
                                                        <SortableItem
                                                            key={value}
                                                            value={value}
                                                            enabled={enabled}
                                                            onCheckboxChange={(checked) => this.onDragCheckboxUpdate(checked, sectionIndex, elementIndex)}
                                                            mapName={this.mapTemplateElementName.bind(this)}
                                                        />
                                                    ))}
                                                </ul>
                                            </SortableContext>
                                        </DndContext>
                                    ))}
                                </div>
                            </div>
                            <div className="adaptiveCardContainer">
                            </div>
                        </div>

                        <div className="footerContainer">
                            <div className="buttonContainer">
                                <Button onClick={this.props.onBackToList} appearance='secondary' >{this.localize("Back")}</Button>
                                <Button disabled={this.isNextBtnDisabled()} id="saveBtn" onClick={(event: any) => this.onNext(event, "AssignAuthorsGroup")} appearance='primary' >{this.localize("Next")}</Button>
                            </div>
                        </div>
                    </div>
                );
            } else if (this.state.page === "AssignAuthorsGroup") {
                return (
                    <div className="templateModule" id="top">
                        <div className="templateContainer">
                            <div className="templateContentContainer">
                                <div className="templateContentContainer__template-abilities">
                                    <h3 className="inputHeaders">
                                        {this.localize('AuthorGroupsText')}
                                    </h3>
                                    <Multiselect
                                        selectedOptions={this.state.selectedAuthorGroups}
                                        options={this.state.authorGroups ?? []}
                                        noMatchMessage={this.localize("NoMatchMessage")}
                                        onTagClick={this.onGroupTagClick}
                                        onSearch={this.onGroupSearchQueryChange}
                                        onSelect={this.onGroupsChange}
                                        onClose={this.onGroupSelectBlur}
                                    />
                                    <h3 className="inputHeaders">
                                        {this.localize('AllowSendAllText')}
                                    </h3>
                                    <CheckBoxWithTooltip
                                        label="Enabled"
                                        checked={this.state.allowSendAll}
                                        onChecked={this.allowSendAllSelected}
                                        tooltip={this.localize('AllowSendAllTooltip')}
                                    />
                                    {/*<h3 className="inputHeaders">*/}
                                    {/*    {this.localize('IsEmailEnabledText')}*/}
                                    {/*</h3>*/}
                                    {/*<CheckBoxWithTooltip*/}
                                    {/*    label="Enabled"*/}
                                    {/*    checked={this.state.isEmailEnabled}*/}
                                    {/*    onChecked={this.isEmailEnabledSelected}*/}
                                    {/*    tooltip={this.localize('IsEmailEnabledTooltip')}*/}
                                    {/*/>*/}
                                    {/*<h3 className="inputHeaders">*/}
                                    {/*    {this.localize('IsPowerAutomateEnabledText')}*/}
                                    {/*</h3>*/}
                                    {/*<CheckBoxWithTooltip*/}
                                    {/*    label="Enabled"*/}
                                    {/*    checked={this.state.isPowerAutomateEnabled}*/}
                                    {/*    onChecked={this.isPowerAutomateEnabledSelected}*/}
                                    {/*    tooltip={this.localize('IsPowerAutomateEnabledTooltip')}*/}
                                    {/*/>*/}
                                </div>
                            </div>
                            <div className="adaptiveCardContainer">
                            </div>
                        </div>

                        <div className="footerContainer">
                            <div className="buttonContainer">
                                <Button onClick={(event) => this.onBack(event, "TemplateCreation")} appearance='secondary' >{this.localize("Back")}</Button>
                                <Button disabled={this.isNextBtnDisabled()} id="saveBtn" onClick={this.onSave.bind(this)} appearance='primary' >{this.localize("SaveTemplate")}</Button>
                            </div>
                        </div>
                    </div>
                );
            } else if (this.state.page === "TemplateSaved") {
                return (
                    <div className="templateModule" id="top" >
                        <div className="templateContainer">
                            <div className="templateContentContainer__success-container" >
                                <ThumbsUp className="templateContentContainer__success-image" />
                                <h2 className="templateContentContainer__sucess-title">{this.localize("TemplateSaved")}</h2>
                                <Button size='medium' onClick={this.props.onBackToList} appearance='primary' >{this.localize("AllTemplates")}</Button>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (<div>Error</div>);
            }
        }
    }

    private isNextBtnDisabled = () => {
        const templateName = this.state.templateName;
        const errorTemplateNameMessage = this.state.errorTemplateNameMessage;
        const banner = this.state.bannerUrl;
        const bannerError = this.state.errorBannerUrlMessage;
        const color = this.state.backgroundColorId;
        const colorError = this.state.errorColorUrlMessage;
        const authorGroups = this.state.selectedAuthorGroups;

        if (this.state.page === "TemplateCreation") {
            return !(templateName && !errorTemplateNameMessage && banner && !bannerError && color && !colorError);
        } else if (this.state.page === "AssignAuthorsGroup") {
            return !(authorGroups.length > 0);
        }
    }

    private addElement = (element: string): void => {
        var newElements = this.state.elements;
        newElements.push(element);
        setTemplateElements(this.localize, this.card, newElements, this.state.textColor)
        this.setState({
            elements: newElements,
            card: this.card,
        }, () => {
            this.updateCard();
        });
    }

    private removeElement = (element: string): void => {
        var newElements = this.state.elements.filter((e) => e !== element);
        setTemplateElements(this.localize, this.card, newElements, this.state.textColor)
        this.setState({
            elements: newElements,
            card: this.card,
        }, () => {
            this.updateCard();
        });
    }

    private attachImage = (response: string): void => {
        setTemplateBanner(this.card, response);
        this.setState({ bannerUrl: response, card: this.card }, () => this.updateCard());
    }

    private onGroupsChange = (selectedItem: IOption, selectedItemsLength: number) => {
        this.setState((prevState) => {
            if (prevState.selectedAuthorGroupsNum < selectedItemsLength) {
                return {
                    selectedAuthorGroups: [...prevState.selectedAuthorGroups, selectedItem],
                    selectedAuthorGroupsNum: selectedItemsLength
                }
            } else {
                const newSelectedOptions = prevState.selectedAuthorGroups.filter(x => x.id !== selectedItem.id)
                return {
                    selectedAuthorGroups: newSelectedOptions,
                    selectedAuthorGroupsNum: selectedItemsLength
                }
            }
        });
    }

    private onGroupSearchQueryChange = async (searchQuery: string): Promise<void | any> => {
        if (!searchQuery) {
            this.setState({
                authorGroups: []
            });
        }
        else if (searchQuery && searchQuery.length <= 2) {
            this.setState({
                loadingGroups: false
            });
        }
        else if (searchQuery && searchQuery.length > 2) {
            this.setState({
                loadingGroups: true
            });

            try {
                const query = encodeURIComponent(searchQuery);
                const response = await searchGroups(query);
                this.setState({
                    authorGroups: response.data,
                    loadingGroups: false
                });
            }
            catch (error: any) {
                return error;
            }
        }
    }

    private allowSendAllSelected = () => {
        this.setState({
            allowSendAll: !this.state.allowSendAll
        });
    }

    private isEmailEnabledSelected = () => {
        this.setState({
            isEmailEnabled: !this.state.isEmailEnabled
        });
    }

    private isPowerAutomateEnabledSelected = () => {
        this.setState({
            isPowerAutomateEnabled: !this.state.isPowerAutomateEnabled
        });
    }

    private onGroupSelectBlur = () => {
        this.setState({
            authorGroups: []
        });
    }

    private onGroupTagClick = (itemId: string) => {
        this.setState((prevState) => {
            return {
                selectedAuthorGroups: prevState.selectedAuthorGroups.filter(x => x.id !== itemId),
                selectedAuthorGroupsNum: prevState.selectedAuthorGroupsNum - 1
            }
        })
    }

    private onSave = async () => {
        const selectedAuthorGroups: string[] = [];
        var backgroundInList = this.state.allTemplateColors.find((f) => f.name === this.state.backgroundColorId);
        if (this.state.selectedAuthorGroups.length > 0) this.state.selectedAuthorGroups.forEach(x => selectedAuthorGroups.push(x.id));
        const template: ITemplate = {
            id: this.props.selectTemplate ? this.state.id : "",
            templateName: this.state.templateName,
            bannerUrl: this.state.bannerUrl,
            backgroundColorId: this.state.backgroundColorId,
            backgroundColorUrl: backgroundInList ? backgroundInList.id : this.state.backgroundColorUrl,
            textColor: this.state.textColor,
            isEmailEnabled: this.state.isEmailEnabled,
            authorGroups: selectedAuthorGroups,
            emailOffSet: this.state.emailOffSet,
            allowSendAll: this.state.allowSendAll,
            isIncidentSummary: this.state.isIncidentSummary,
            isPowerAutomateEnabled: this.state.isPowerAutomateEnabled,
            elements: this.state.elements,
            creatorId: this.state.creatorId,
            creatorName: this.state.creatorName,
        };

        this.setState({ forceDisableButton: !this.state.forceDisableButton });

        if (this.state.exists) {
            await this.editTemplate(template)
        } else {
            await this.postTemplate(template);
        }

        await this.props.getTemplateColorsList();
        await this.props.getAllTemplatesList();

        this.setState({ page: "TemplateSaved" })
    }

    private postTemplate = async (template: ITemplate) => {
        try {
            return await createTemplate(template);
        } catch (error) {
            throw error;
        }
    }

    private editTemplate = async (template: ITemplate) => {
        try {
            await updateTemplate(template);
        } catch (error) {
            return error;
        }
    }

    public escFunction(event: any) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            dialog.url.submit();
        }
    }

    private onNext = (event: any, page: string) => {
        this.setState({
            page
        }, () => {
            this.updateCard();
        });
    }

    private onBack = (event: any, page: string) => {
        this.setState({
            page
        }, () => {
            this.updateCard();
        });
    }

    private onTemplateNameChanged = (event: any) => {
        //const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        var templateNameError = "";
        var currentTemplate = this.state.allTemplates.find((f) => f.templateName === event.target.value);
        if (currentTemplate) {
            templateNameError = "Template Name already used"
        }

        var selectedTemplate: ITemplate = {
            id: this.state.id,
            templateName: event.target.value
        }

        var allTemplatesList = this.state.allTemplates.filter((f) => f.id !== this.state.id);
        allTemplatesList.push(selectedTemplate);

        this.setState({
            templateName: event.target.value,
            errorTemplateNameMessage: templateNameError,
            allTemplates: allTemplatesList
        })
    }

    private onTemplateBannerChanged = (bannerUrl: string) => {
        let url = bannerUrl.toLowerCase();
        if (!((url === "") || (url.startsWith("https://") || (url.startsWith("data:image/png;base64,")) || (url.startsWith("data:image/jpeg;base64,")) || (url.startsWith("data:image/gif;base64,"))))) {
            this.setState({
                errorBannerUrlMessage: "URL must start with https://"
            });
        } else {
            this.setState({
                errorBannerUrlMessage: ""
            });
        }

        setTemplateBanner(this.card, bannerUrl);

        this.setState({
            bannerUrl: bannerUrl,
            card: this.card,
        }, () => {
            this.updateCard();
        });
        
    }

    private onTemplateColorGenerated = async () => {

        var response = await createTemplateColor(this.state.backgroundColorId)
        setTemplateColor(this.card, response.data)
        this.setState({
            backgroundColorUrl: response.data,
            card: this.card,
        }, () => {
            this.updateCard();
        });
    }

    //private onTextColorChange = (event: any, itemsData: any) => {
    //    var textColorId = this.state.allTextColors.find((f) => f.name === itemsData.optionValue).id;
    //    setTemplateTextColor(this.card, textColorId)
    //    this.setState({
    //        textColor: textColorId,
    //        textColorDisplay: itemsData.optionValue,
    //        card: this.card,
    //    }, () => {
    //        this.updateCard();
    //    });
    //}

    private onTextColorChange = (event: any, itemsData: any) => {
        const selectedColor = this.state.allTextColors.find((f) => f.id === itemsData.optionValue);
        if (!selectedColor) return;

        setTemplateTextColor(this.card, selectedColor.id);
        this.setState({
            textColor: selectedColor.id,
            textColorDisplay: selectedColor.name,
            card: this.card,
        }, () => {
            this.updateCard();
        });
    }

    onDragEnd(event: DragEndEvent, sectionIndex: number) {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const section = this.state.sections[sectionIndex];
        const oldIndex = section.findIndex(item => item.value === active.id);
        const newIndex = section.findIndex(item => item.value === over.id);

        const items = Array.from(section);
        const [reorderedItem] = items.splice(oldIndex, 1);
        items.splice(newIndex, 0, reorderedItem);

        const newSections = [...this.state.sections];
        newSections[sectionIndex] = items;

        const elements = newSections.map(array => array.filter(x => x.enabled).map(({ value, enabled }) => value)).flat();
        setTemplateElements(this.localize, this.card, elements, this.state.textColor)
        this.setState({
            sections: newSections,
            card: this.card
        }, () => {
            this.updateCard();
        });
    }

    private onDragCheckboxUpdate = (value: boolean, sectionIndex: number, elementIndex: number): void => {
        const sectionsCopy = Array.from(this.state.sections);
        const items = Array.from(sectionsCopy[sectionIndex]);
        items[elementIndex].enabled = value;
        sectionsCopy[sectionIndex] = items;

        const elements = sectionsCopy.map(array => array.filter(x => x.enabled).map(({value, enabled}) => value)).flat();
        setTemplateElements(this.localize, this.card, elements, this.state.textColor)

        this.setState({
            sections: sectionsCopy,
            elements: sectionsCopy.map(array => array.filter(x => x.enabled).map(({value, enabled}) => value)).flat(),
            card: this.card,
        }, () => {
            this.updateCard();
        });
    }

    private updateCard = () => {
        const adaptiveCard = new AdaptiveCards.AdaptiveCard();
        AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
            result.outputHtml = markDownToHtml(text);
            result.didProcess = true;
        };
        adaptiveCard.parse(this.state.card);
        const renderedCard = adaptiveCard.render() as HTMLElement;
        const adaptiveCardContainer = document.getElementsByClassName('adaptiveCardContainer')[0];

        if (adaptiveCardContainer !== null && adaptiveCardContainer !== undefined) {
            const container = adaptiveCardContainer.firstChild;
            if (container != null) {
                container.replaceWith(renderedCard);
            } else {
                adaptiveCardContainer.appendChild(renderedCard);
            }
        }
    }
}

const mapStateToProps = (state: any) => {
    return { templatesList: state.templatesList, templateColorsList: state.templateColorsList };
}

const newTemplateWithTranslation = withTranslation()(NewTemplate);
export default connect(mapStateToProps, { getAllTemplatesList, getTemplateColorsList })(newTemplateWithTranslation);
